<template>
  <div class="section">
    <div class="columns">
      <div class="column is-half-desktop is-offset-one-quarter-desktop">
        <h1 class="subtitle">パスワード再設定</h1>
        <p class="block">
          ログインパスワードの再設定を行います。<br />以下の項目を入力し、「確認メールを送る」ボタンを押してください。
        </p>
        <input
          class="input"
          type="email"
          v-model="email"
          name="forgotPassword_email"
          placeholder="メールアドレス"
        />
        <div class="formbuttons">
          <button class="button is-primary" v-on:click="passwordReset()">
            確認メールを送る
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { auth } from '@/plugins/firebase';

export default {
  name: 'ForgotPassword',
  data: function () {
    return {
      email: ''
    };
  },
  methods: {
    passwordReset() {
      const that = this;
      auth
        .sendPasswordResetEmail(this.email)
        .then(function () {
          that.email = '';
          alert('パスワードの再設定メールを送信しました。');
        })
        .catch(function (err) {
          console.log(err);
        });
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../assets/scss/forgot-password.scss';
</style>
